import { el } from './locales/el';
import { en } from './locales/en';

export const translations = {
    el,
    en
};

export const normalizeLanguageCode = (language) => {
    if (language === 'el' || language === 'el-GR') return 'el';
    if (language === 'en' || language === 'en-US') return 'en';
    return 'el';
};

export const languages = {
    el: {
        name: "Ελληνικά",
        flag: "/flags/gr.png",
        culture: "el-GR"
    },
    en: {
        name: "English",
        flag: "/flags/usa.png",
        culture: "en-US"
    }
};